export const API_ENDPOINTS = {
  REGISTER: 'create-customer',
  REGISTER_CUSTOMER: 'register',
  PRODUCTS: 'products',
  LOGOUT: 'logout',
  TOKEN: 'token',
  CUSTOMER_LOGIN: 'login',
  LOGIN: 'userlogin',
  REFRESH_TOKEN: 'refresh-token',
  CHANGE_PASSWORD: 'change-password',
  FORGET_PASSWORD: 'fp-send-otp',
  VERIFY_EMAIL_ADDRESS: 'validate-customer-email',
  VERIFY_FORGET_PASSWORD_OTP: 'fp-verify-otp',
  RESET_PASSWORD: 'fp-reset-password',
  SEND_OTP: 'generate-otp',
  VERIFY_SEND_OTP: 'verify-otp',
  PRODUCT: 'get-products',
  PROUCT_BY_UUID: 'product-by-uuid',
  CREATE_QUOTE: 'create-customer-quote',
  QUOTE_BY_ID: 'quote-by-uuid',
  DELETE_PRODUCT_QUOTE: 'remove-customer-quote-product',
  ADD_PRODUCT_QUOTE: 'add-customer-quote-product',
  PLACE_ORDER: 'place-customer-order',
  UPDATE_PRODUCT_QUOTE: 'update-customer-quote-product',
  BOOKING_DATE: 'product-booking-calendar',
  ADDRESS_LOOKHP: 'lookup',
  CHECK_CUSTOMER_KYC: 'customerKYC',
  ORDER_LIST: 'order-by-uuid',
  PAYMENT_INITIATE: 'initiate-payment-process',
  ORDER_PAYMENT: 'complete-order',
  Add_UPDATE_CUSTOMER: 'update-customer-address',
  GET_CUSTOMER: 'customerkyc-details',
  GET_PRODUCT_PRICING_DAY: 'get-product-day-rate-pricing',
  GET_QUATE_CHARGES: 'get-quote-charges',
  QUATE_CHARGES: 'quote-charges',
  UPDATE_CUSTOMER_QUOTE: 'update-customer-quote',
  GET_PRODUCT_PRICING: 'get-product-pricing',
  GET_CUSTOMER_INFO: 'get-customer-information',
  GET_TERMS_CONDITIONS_INFO: 'customer-termsandconditions',
  CUSTOMER_FRAUDCHECK: 'customer-fraudcheck',
  DELETE_QUATE: 'delete-quote',
  GET_PRODUCT_VARIANT: 'get-product-variant',
  GET_STORE_PRODUCTS: "get-store-products",
  GET_ADDON_PRODUCTS: "get-addon-products",
  GET_STORE_FROM_SLUG: 'get-store-from-slug',
  VERIFY_PAYMENT_SESSION: 'verify-payment-session',
  INITIATE_ORDER_PURCHASE: 'initiate-order-purchase',
  GET_PURCHASE_ORDER: 'get-purchase-order',
  CREATE_PAYMENT_SESSION: 'create-payment-session',
  APPLY_PROMOCODE: 'redeem-discount',
  REMOVE_PROMOCODE: 'remove-discount',
  CHECKOUT_ORDER: 'order/checkout',
  EXTENDED_RENTAL_QUOTE_CHARGES: 'extended-rental-quote-charges',
};

export const OPEN_API = [
  API_ENDPOINTS.DELETE_QUATE,
  API_ENDPOINTS.REGISTER,
  API_ENDPOINTS.REGISTER_CUSTOMER,
  API_ENDPOINTS.PRODUCTS,
  API_ENDPOINTS.CUSTOMER_LOGIN,
  API_ENDPOINTS.REFRESH_TOKEN,
  API_ENDPOINTS.PROUCT_BY_UUID,
  API_ENDPOINTS.CREATE_QUOTE,
  API_ENDPOINTS.QUOTE_BY_ID,
  API_ENDPOINTS.DELETE_PRODUCT_QUOTE,
  API_ENDPOINTS.ADD_PRODUCT_QUOTE,
  API_ENDPOINTS.GET_QUATE_CHARGES,
  API_ENDPOINTS.QUATE_CHARGES,
  API_ENDPOINTS.BOOKING_DATE,
  API_ENDPOINTS.VERIFY_EMAIL_ADDRESS,
  API_ENDPOINTS.FORGET_PASSWORD,
  API_ENDPOINTS.VERIFY_FORGET_PASSWORD_OTP,
  API_ENDPOINTS.RESET_PASSWORD,
  API_ENDPOINTS.SEND_OTP,
  API_ENDPOINTS.VERIFY_SEND_OTP,
  API_ENDPOINTS.CHANGE_PASSWORD,
  API_ENDPOINTS.UPDATE_CUSTOMER_QUOTE,
  API_ENDPOINTS.GET_PRODUCT_PRICING,
  API_ENDPOINTS.GET_PRODUCT_VARIANT,
  API_ENDPOINTS.GET_STORE_PRODUCTS,
  API_ENDPOINTS.GET_ADDON_PRODUCTS
];
